import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const payRateMarketByLocationResponse = z.array(
  z.object({
    company_name: z.string(),
    position_type: z.string(),
    avg_pay_rate_with_company_bonus: z.number(),
    avg_market_pay_rate: z.number(),
    fill_rate: z.number(),
    pay_rate_difference_with_market: z.number(),
  })
)

export type PayRateMarketByLocation = z.infer<
  typeof payRateMarketByLocationResponse
>

export async function getPayRateMarketByLocation(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/pay_rate_market_by_location', data, { signal })
    .then((response) => response.data)
    .then(payRateMarketByLocationResponse.parse)
}

export async function getPayRateMarketByLocationCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/pay_rate_market_by_location/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
